import { render, staticRenderFns } from "./ClaimRow.vue?vue&type=template&id=2fd6bf8d&scoped=true"
import script from "./ClaimRow.vue?vue&type=script&lang=ts"
export * from "./ClaimRow.vue?vue&type=script&lang=ts"
import style0 from "./ClaimRow.vue?vue&type=style&index=0&id=2fd6bf8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd6bf8d",
  null
  
)

export default component.exports